module.exports = __webpack_public_path__ + "static/media/04_a_background.174714ab.jpg";